import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

export function useBuyerUnreadCount(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["/api/buyer/notifications/unread-count"],
    queryFn: async () => {
      const res = await fetch("/api/buyer/notifications/unread-count");
      if (!res.ok) throw new Error("Failed to fetch buyer unread count");
      return res.json() as Promise<{ count: number }>;
    },
    enabled: options?.enabled ?? true,
    refetchInterval: 30000,
  });
}

export function useMarkAllBuyerNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await fetch("/api/buyer/notifications/mark-all-read", {
        method: "PATCH",
      });
      if (!res.ok) throw new Error("Failed to mark all as read");
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/buyer/notifications/unread-count"] });
    },
  });
}
